module.exports = __webpack_public_path__ + "img/icon-coffer-bronze.61d045ba.svg";